import * as React from 'react'
import { ArrowLeftIcon } from 'lucide-react'

import { cn } from '../../../lib/utils'
import { Button } from '../../../components/ui/button'

export interface DetailHeaderProps {
  title: string
  backLabel: string
  onBack: () => void
  trailing?: React.ReactNode
  actions?: React.ReactNode
  className?: string
}

export function DetailHeader({
  title,
  backLabel,
  onBack,
  trailing,
  actions,
  className
}: DetailHeaderProps) {
  return (
    <div
      className={cn(
        'flex flex-wrap items-center gap-x-3 gap-y-2 border-b border-line pb-3',
        className
      )}
    >
      <Button variant="ghost" size="sm" onClick={onBack} className="-ml-2 text-ink-3">
        <ArrowLeftIcon className="size-4" />
        <span className="text-xs font-medium">{backLabel}</span>
      </Button>
      <div className="h-4 w-px shrink-0 bg-line" />
      <div className="m-0 flex min-w-0 flex-1 items-center gap-2.5">
        <h1 className="m-0 truncate text-xl font-semibold text-ink">{title}</h1>
        {trailing && <div className="shrink-0">{trailing}</div>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  )
}
